import styled from 'styled-components'

export const Container = styled.aside`
  width: 250px;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textPrimary};
  border-right: 1px solid ${({ theme }) => theme.colors.borderDefault};
`

export const SidebarBrand = styled.div`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.7rem;
  height: 60px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
  transition: background-color 0.15s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.03)'
        : theme.colors.borderSubtle};
  }
`

export const SidebarMenuContainer = styled.div`
  overflow-y: auto;
  height: calc(100vh - 60px);
  padding: 0.85rem 0.75rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

export const HelpSection = styled.div`
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borderDefault};
`

export const BrandName = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`

export const NavLabel = styled.span`
  display: block;
  margin: 0 0.5rem 0.55rem;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const NavbarLinkContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const NavbarMenu = styled.li`
  width: 100%;
  margin: 0;
  padding: 0;
  border-radius: 10px;
  background: ${({ $active, theme }) => {
    if (!$active) return 'transparent'
    return theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.14)'
      : 'rgba(62, 207, 142, 0.1)'
  }};
  transition: background-color 0.15s ease;

  &:hover {
    background: ${({ $active, theme }) => {
      if ($active) {
        return theme.name === 'dark'
          ? 'rgba(62, 207, 142, 0.18)'
          : 'rgba(62, 207, 142, 0.14)'
      }
      return theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.04)'
        : theme.colors.borderSubtle
    }};
  }
`

export const MenuLink = styled.div`
  a {
    display: flex;
    align-items: center;
    gap: 0.7rem;
    width: 100%;
    padding: 0.7rem 0.85rem;
    border-radius: 10px;
    text-decoration: none;
    font-size: 0.9375rem;
    line-height: 1.3;
    color: inherit;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: ${({ $active }) => ($active ? '1.35rem' : '0')};
      border-radius: 999px;
      background: ${({ theme }) => theme.colors.action.primary.bg};
      transition: height 0.15s ease;
    }
  }
`

export const LinkName = styled.span`
  flex: 1;
  min-width: 0;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.textPrimary : theme.colors.textSecondary};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  letter-spacing: -0.01em;
`

export const MenuIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 8px;
  background: ${({ $active, theme }) => {
    if (!$active) return 'transparent'
    return theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.2)'
      : 'rgba(62, 207, 142, 0.12)'
  }};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.action.primary.bg : theme.colors.textMuted};
  transition: background-color 0.15s ease, color 0.15s ease;

  & > span {
    font-size: 1.05rem !important;
    line-height: 1;
  }
`
